const template = `
	<span>
		<img
			src="/img/pixel.png"
			v-if="code"
			:class="'flag flag-' + code"
			v-title="!noTitle ? countryName : null"
		/>
		<span v-else class="empty-flag"></span>
	</span>
`;

export default {
	template: template,
	props: ['cc', 'no-title'],
	computed: {
		code() {
			let code = String(this.cc || '').toLowerCase();
			if (code === 'cs' || !/^[a-z]{2}$/.test(code)) return null;
			return code;
		},
		countryName() {
			return this.getCountryByCode(this.code) || this.cc;
		}
	}
};
